import { UseQueryResult, useQuery } from "react-query";

import { useAxios } from "../../hooks/useAxios";
import { IWorkspaceDomain } from "../../types";

export interface IUseFetchWorkspaceDomainsResponse {
  workspace_domains: Array<IWorkspaceDomain>;
}

export default function useFetchWorkspaceDomains(): UseQueryResult<IUseFetchWorkspaceDomainsResponse> {
  const axios = useAxios();

  const query = useQuery<IUseFetchWorkspaceDomainsResponse>(
    ["workspaceDomains"],
    async (): Promise<IUseFetchWorkspaceDomainsResponse> => {
      return await axios
        .get(`/v1/workspaces/domains`, {})
        .then((r) => r.data as IUseFetchWorkspaceDomainsResponse);
    }
  );

  return query;
}
